
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PoliticaDePrivacidadePage() {
  const sections = [
    {
      icon: 'ri-user-line',
      title: '1. Quem Somos',
      content: `A ViaEducacaoCursos é uma marca de Vrc Programas Treinamentos e Cursos Educacionais Ltda, inscrita no CNPJ 62.934.863/0001-93. Somos responsáveis pelo tratamento dos seus dados pessoais coletados por meio deste site e de nossas plataformas de ensino.

Para dúvidas sobre esta Política, entre em contato pelo e-mail: contato@viaeducacaocursos.com.br`
    },
    {
      icon: 'ri-database-2-line',
      title: '2. Dados que Coletamos',
      content: `Podemos coletar os seguintes dados pessoais:

• **Dados de identificação:** nome completo, e-mail, telefone e CPF (quando necessário para emissão de nota fiscal ou certificado).
• **Dados de acesso:** endereço IP, tipo de navegador, sistema operacional, páginas visitadas e tempo de permanência.
• **Dados de pagamento:** processados de forma segura por plataformas parceiras (Hotmart, Kiwify, etc.). Não armazenamos dados de cartão de crédito.
• **Dados de comunicação:** mensagens enviadas via formulários de contato, WhatsApp ou e-mail.
• **Dados de uso da plataforma:** progresso nos cursos, certificados emitidos e interações com o conteúdo.`
    },
    {
      icon: 'ri-focus-3-line',
      title: '3. Finalidade do Tratamento',
      content: `Utilizamos seus dados para:

• Processar matrículas e pagamentos nos cursos e programas;
• Emitir certificados de conclusão;
• Enviar comunicações sobre aulas, atualizações e novidades;
• Responder dúvidas e oferecer suporte ao aluno;
• Enviar materiais educativos e ofertas relevantes (com possibilidade de descadastro a qualquer momento);
• Cumprir obrigações legais e fiscais;
• Melhorar continuamente nossos produtos e serviços;
• Realizar análises estatísticas e de desempenho da plataforma.`
    },
    {
      icon: 'ri-scales-3-line',
      title: '4. Base Legal',
      content: `O tratamento dos seus dados é fundamentado nas seguintes bases legais previstas na Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018):

• **Consentimento:** quando você preenche formulários ou se inscreve em nossa newsletter.
• **Execução de contrato:** para processar sua matrícula e entregar o serviço contratado.
• **Obrigação legal:** para cumprimento de exigências fiscais e regulatórias.
• **Legítimo interesse:** para melhorar nossos serviços e comunicar novidades relevantes.`
    },
    {
      icon: 'ri-share-line',
      title: '5. Compartilhamento de Dados',
      content: `Seus dados podem ser compartilhados com:

• **Plataformas de pagamento e hospedagem de cursos** (ex.: Hotmart, Kiwify) para processamento de transações;
• **Ferramentas de e-mail marketing** para envio de comunicações autorizadas;
• **Ferramentas de análise** (ex.: Google Analytics, Meta Pixel) para mensuração de desempenho;
• **Autoridades públicas**, quando exigido por lei ou ordem judicial.

Não vendemos, alugamos ou cedemos seus dados a terceiros para fins comerciais próprios.`
    },
    {
      icon: 'ri-cookie-line',
      title: '6. Cookies e Tecnologias de Rastreamento',
      content: `Utilizamos cookies e tecnologias similares para:

• Manter sua sessão ativa na plataforma;
• Lembrar suas preferências de navegação;
• Mensurar o desempenho de nossas páginas e campanhas (Google Analytics, Meta Pixel);
• Personalizar anúncios relevantes para você.

Você pode gerenciar ou desativar cookies nas configurações do seu navegador. A desativação pode afetar algumas funcionalidades do site.`
    },
    {
      icon: 'ri-lock-password-line',
      title: '7. Segurança dos Dados',
      content: `Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado, perda, alteração ou divulgação indevida, incluindo:

• Conexões criptografadas (HTTPS/SSL);
• Acesso restrito aos dados por colaboradores autorizados;
• Monitoramento contínuo de segurança;
• Parceiros certificados com padrões de segurança reconhecidos.

Apesar de nossos esforços, nenhum sistema é 100% seguro. Em caso de incidente, notificaremos os titulares afetados conforme exigido pela LGPD.`
    },
    {
      icon: 'ri-time-line',
      title: '8. Retenção de Dados',
      content: `Mantemos seus dados pelo tempo necessário para:

• Cumprir as finalidades descritas nesta Política;
• Atender obrigações legais e fiscais (mínimo de 5 anos para dados contábeis);
• Resolver disputas e fazer cumprir nossos acordos.

Após o período de retenção, os dados são excluídos ou anonimizados de forma segura.`
    },
    {
      icon: 'ri-shield-user-line',
      title: '9. Seus Direitos (LGPD)',
      content: `Como titular de dados, você tem os seguintes direitos garantidos pela LGPD:

• **Confirmação e acesso:** saber se tratamos seus dados e obter uma cópia;
• **Correção:** solicitar a atualização de dados incompletos ou incorretos;
• **Anonimização ou exclusão:** pedir a eliminação de dados desnecessários;
• **Portabilidade:** receber seus dados em formato estruturado;
• **Revogação do consentimento:** retirar seu consentimento a qualquer momento;
• **Oposição:** opor-se ao tratamento em determinadas situações;
• **Informação sobre compartilhamento:** saber com quem compartilhamos seus dados.

Para exercer seus direitos, entre em contato pelo e-mail: contato@viaeducacaocursos.com.br`
    },
    {
      icon: 'ri-refresh-line',
      title: '10. Atualizações desta Política',
      content: `Esta Política pode ser atualizada periodicamente para refletir mudanças em nossas práticas ou na legislação. Recomendamos que você a revise regularmente. A data da última atualização está indicada no topo desta página.

Alterações significativas serão comunicadas por e-mail ou por aviso em destaque no site.`
    }
  ];

  const lastUpdate = '15 de junho de 2025';

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-slate-50 to-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 rounded-full text-slate-600 text-sm font-medium mb-6">
              <i className="ri-shield-check-line"></i>
              Última atualização: {lastUpdate}
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Política de Privacidade
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Sua privacidade é importante para nós. Saiba como coletamos, usamos e protegemos seus dados pessoais de acordo com a LGPD.
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="pb-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">

            {/* Intro card */}
            <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-2xl p-8 mb-12 text-white">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl flex-shrink-0">
                  <i className="ri-information-line text-2xl text-white"></i>
                </div>
                <div>
                  <h2 className="text-xl font-bold mb-2">Resumo Rápido</h2>
                  <p className="text-slate-300 leading-relaxed text-sm">
                    Coletamos apenas os dados necessários para oferecer nossos serviços educacionais. Não vendemos seus dados. Você pode solicitar a exclusão a qualquer momento. Esta política está em conformidade com a <strong className="text-white">Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)</strong>.
                  </p>
                </div>
              </div>
            </div>

            {/* Sections */}
            <div className="space-y-8">
              {sections.map((section, index) => (
                <div key={index} className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-11 h-11 flex items-center justify-center bg-slate-100 rounded-xl flex-shrink-0">
                      <i className={`${section.icon} text-xl text-slate-700`}></i>
                    </div>
                    <h2 className="text-xl font-bold text-gray-900">{section.title}</h2>
                  </div>
                  <div className="text-gray-600 leading-relaxed text-sm whitespace-pre-line pl-0">
                    {section.content.split('\n').map((line, i) => {
                      if (line.startsWith('• **') && line.includes(':**')) {
                        const parts = line.replace('• **', '').split(':**');
                        return (
                          <p key={i} className="mb-2 flex items-start gap-2">
                            <span className="text-slate-400 mt-0.5">•</span>
                            <span><strong className="text-gray-800">{parts[0]}:</strong>{parts[1]}</span>
                          </p>
                        );
                      }
                      if (line.startsWith('• ')) {
                        return (
                          <p key={i} className="mb-2 flex items-start gap-2">
                            <span className="text-slate-400 mt-0.5">•</span>
                            <span>{line.replace('• ', '')}</span>
                          </p>
                        );
                      }
                      if (line.trim() === '') return <div key={i} className="mb-3"></div>;
                      return <p key={i} className="mb-3">{line}</p>;
                    })}
                  </div>
                </div>
              ))}
            </div>

            {/* Contact */}
            <div className="mt-12 bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-8 text-center border border-slate-200">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-800 rounded-full mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Dúvidas sobre Privacidade?</h3>
              <p className="text-gray-600 text-sm mb-4">
                Entre em contato com nosso Encarregado de Proteção de Dados (DPO):
              </p>
              <a
                href="mailto:contato@viaeducacaocursos.com.br"
                className="inline-flex items-center gap-2 px-6 py-3 bg-slate-800 text-white text-sm font-medium rounded-full hover:bg-slate-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                contato@viaeducacaocursos.com.br
              </a>
              <p className="text-xs text-gray-500 mt-4">
                Vrc Programas Treinamentos e Cursos Educacionais Ltda — CNPJ 62.934.863/0001-93
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
